import Link from 'next/link'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import tailwindConfig from 'tailwind.config'
import CircleIcon from '@/components/icons/CircleIcon'
import { TaskMenuItem } from '@/types/task-menu-item'
import VerifyRoundIcon from '@/components/icons/VerifyRoundIcon'
import TaskStatus from '@/enums/taskStatus'
import CloseIcon from '@/components/icons/CloseIcon'

interface IProps {
  menuItem?: TaskMenuItem
  index: number
}

export const SideMenuItem = ({ index, menuItem, ...props }: IProps) => {
  const {} = props

  const getActiveLinkClassNames = (isSelected: boolean) => {
    if (isSelected)
      return 'bg-pressedMenuItem border-y border-t-primaryAdditional200 border-b-primaryAdditional200'
    else return ''
  }

  // The `menuItem` prop is optional on IProps. All render paths below
  // dereference its members, so bail out cleanly when callers omit it.
  if (!menuItem) return null
  const item: TaskMenuItem = menuItem

  const formatTaskUrl = () => {
    if (item.workflowInstanceId)
      return `${item.href}?workflow_id=${item.workflowInstanceId}`
    else return `${item.href}`
  }

  return (
    <>
      <li
        key={index}
        className={`border-t border-t-grey200 text-base font-medium ${getActiveLinkClassNames(
          item.isSelected
        )}`}
      >
        <Link
          href={formatTaskUrl()}
          className={`flex gap-2 items-center p-3 ${
            !!getActiveLinkClassNames(item.isSelected) && 'text-royalBlue'
          } ${item.taskStatus === TaskStatus.TERMINATED && '!text-red-900'} ${
            index === 0 && 'pointer-events-none'
          }
            ${item.isDisabled == true && ' pointer-events-none opacity-40'}
            `}
        >
          {item.isCompleted === true ? (
            <VerifyRoundIcon mode="success" size={24} />
          ) : item.taskStatus === TaskStatus.TERMINATED ? (
            <span className="w-6 h-6">
              <CloseIcon className="w-6 h-6" />
            </span>
          ) : (
            <CircleIcon
              size={24}
              color={
                !!getActiveLinkClassNames(item.isSelected)
                  ? tailwindConfig.theme.extend.colors.royalBlue
                  : tailwindConfig.theme.extend.colors.neutralsAdditional500
              }
            />
          )}
          <span
            className={`text-base break-all ${
              item.isCompleted === true ? 'line-through' : ''
            }`}
          >
            <FormattedMessage id={item.label} />
          </span>
        </Link>
      </li>
    </>
  )
}
